<template>
  <q-dialog
    ref="dialogRef"
    transition-hide="fade"
    transition-show="fade"
    transition-duration="200"
  >
    <q-card
      class="q-dialog-plugin dark:bg-d-neutral-10 p-16 min-w-[320px]"
    >
      <!--  class="flex items-center bg-primary-pure py-16 px-24 text-title-2 text-white" -->
      <header class="text-headline-1 !font-normal text-primary-pure">
        {{ title }}
      </header>

      <div class="flex flex-col justify-between min-h-120">
        <p
          class="text-paragraph-2 text-neutral-70 font-medium dark:text-white/70 mt-16"
        >
          {{ text }}
        </p>

        <div
          class="flex items-center justify-end gap-8 mt-24 flex-nowrap"
        >
          <OButton
            size="lg"
            tertiary
            class="dark:bg-d-neutral-40 dark:!border-transparent !px-14 w-full"
            :class="cancelClass"
            @click="onDialogCancel"
          >
            {{ cancelText }}
          </OButton>
          <OButton
            size="lg"
            primary
            autofocus
            class="!px-14 w-full"
            :class="confirmClass"
            @click="onDialogOK"
          >
            {{ confirmText }}
          </OButton>
        </div>
      </div>
    </q-card>
  </q-dialog>
</template>

<script setup>
import { useDialogPluginComponent } from 'quasar'
import OButton from 'components/Button/OButton.vue'

const { dialogRef, onDialogOK, onDialogCancel } =
  useDialogPluginComponent()

const props = defineProps({
  title: String,
  text: {
    type: String,
    default: 'Texto padrão',
  },
  confirmText: {
    type: String,
    default: 'Confirmar',
  },
  cancelText: {
    type: String,
    default: 'Cancelar',
  },
  confirmClass: String,
  cancelClass: String,
})

defineEmits([...useDialogPluginComponent.emits])
</script>
